//TODO : Refactor after ai
import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: "brand" | "neutral" | "error";
  variant?: "filled" | "light" | "outline" | "ghost" | "link";
  size?: "lg" | "md" | "sm" | "xs" | "xxs";
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  iconOnly?: boolean;
  loading?: boolean;
  children?: ReactNode;
}

/** Beyond UI Button — 3 colours x 5 styles x 5 sizes, icon-only and loading. */
export function Button({
  color = "brand",
  variant = "filled",
  size = "md",
  leadingIcon,
  trailingIcon,
  iconOnly = false,
  loading = false,
  disabled = false,
  children,
  className = "",
  ...rest
}: ButtonProps) {
  const iconPx = size === "lg" ? 24 : size === "xxs" ? 16 : 20;
  const box = { display: "grid", placeItems: "center", width: iconPx, height: iconPx } as const;

  return (
    <button
      type="button"
      className={`bui-btn ${className}`}
      data-color={color}
      data-style={variant}
      data-size={size}
      data-icon-only={iconOnly || undefined}
      data-state={loading ? "loading" : disabled ? "disabled" : undefined}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <Spinner size={iconPx} />
      ) : (
        leadingIcon && <span style={box}>{leadingIcon}</span>
      )}
      {!iconOnly && <span className="bui-btn__label">{children}</span>}
      {!loading && trailingIcon && <span style={box}>{trailingIcon}</span>}
    </button>
  );
}
